import React, { ReactElement, cloneElement, isValidElement } from 'react';
import NextLink, { LinkProps } from 'next/link';
import { useStoreState } from 'base/store';
import { getNativePage } from 'base/utils/app';

export type { LinkProps } from 'next/link';

export type ILinkProps = LinkProps & {
    children?: React.ReactNode;
}

export const Link: React.FC<ILinkProps> = props => {
    const { ua: { isApp } } = useStoreState('rootStore');

    const { href, children } = props;

    if (isApp && typeof href === 'string' && href.trim() !== '') {
        const pathname = href.replace(/[?#].*$/, '');
        const nativePage = getNativePage(pathname);

        if (nativePage) {
            if (typeof children === 'string' || typeof children === 'number') {
                return (
                    <a
                        onClick={(e) => {
                            nativePage.callback(pathname, href)
                            e.preventDefault();
                        }}
                    >
                        {children}
                    </a>
                )
            } else if (isValidElement(children)) {
                return cloneElement((children as ReactElement), {
                    onClick: (e: any) => {
                        nativePage.callback(pathname, href)
                        e.preventDefault();
                    }
                })
            } else {
                return (
                    <span
                        onClick={() => {
                            nativePage.callback(pathname, href)
                        }}
                    >
                        {children}
                    </span>
                )
            }
        }
    }

    return <NextLink prefetch={false} {...props}/>
};

export default Link;